"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = require("prop-types");
var _react = _interopRequireDefault(require("react"));
var _ssrIcon = _interopRequireDefault(require("@ingka/ssr-icon"));
var _arrowRight = _interopRequireDefault(require("@ingka/ssr-icon/paths/arrow-right"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const JumboButton = _ref => {
  let {
    href,
    newWindow,
    loadingSrText,
    prefix,
    htmlType,
    disabled,
    className,
    onClick,
    label,
    loading,
    footer,
    children,
    variant,
    inverseTheme,
    ...others
  } = _ref;
  function onKeyUpHandler(e) {
    if (disabled || loading || e.key !== ' ') {
      return true;
    }
    e.target.click();
  }
  const classes = (0, _classnames.default)(`${prefix}jumbo-btn`, `${prefix}jumbo-btn--${variant}`, inverseTheme && `${prefix}jumbo-btn--inverse`, footer && `${prefix}jumbo-btn--footer`, loading && `${prefix}jumbo-btn--loading`, className);
  const JumboButtonTag = href ? 'a' : 'button';
  const onKeyUp = JumboButtonTag === 'a' ? onKeyUpHandler : null;
  const role = href ? 'button' : null;
  const linkProps = {
    ...(!disabled && {
      href
    }),
    ...(newWindow && {
      target: '_blank'
    })
  };
  const button = _react.default.createElement(JumboButtonTag, _extends({
    type: !href ? htmlType : null,
    role: role,
    disabled: href ? null : disabled,
    "aria-disabled": loading,
    className: classes,
    onClick: onClick,
    onKeyUp: onKeyUp
  }, linkProps, others), _react.default.createElement("span", {
    className: `${prefix}jumbo-btn__inner`
  }, children, label && _react.default.createElement("span", {
    className: `${prefix}jumbo-btn__label`
  }, label), loading && _react.default.createElement("span", {
    className: `${prefix}jumbo-btn__loader`
  }, loadingSrText), _react.default.createElement("span", {
    className: `${prefix}jumbo-btn__icon`
  }, _react.default.createElement(_ssrIcon.default, {
    prefix: prefix,
    paths: _arrowRight.default
  }))));
  return button;
};
JumboButton.defaultProps = {
  disabled: false,
  htmlType: 'button',
  variant: 'primary',
  prefix: '',
  loadingSrText: 'Loading…'
};
var _default = JumboButton;
exports.default = _default;